/**
 * Detecta si un árbol tipo 14 tiene 3 niveles (p. ej. Departamento → Provincia → Distrito).
 * El legado Chile es de 2 niveles (Región → Comuna) y no debe activar el buscador.
 */
export function hasThreeLevelType14Tree(values: unknown): boolean {
  const tree = parseJsonIfString(values);
  if (!Array.isArray(tree) || tree.length === 0) {
    return false;
  }
  const firstChild = tree[0]?.sub?.[0];
  return Array.isArray(firstChild?.sub) && firstChild.sub.length > 0;
}

/**
 * Buscador en subniveles del tipo 14.
 * `fielddependencies.searchableSublevels` fuerza true/false; si no viene, se infiere por árbol de 3 niveles.
 */
/** Opciones del nivel actual son hojas (sin `sub`), p. ej. Responsable bajo Detalle. */
export function isType14LeafOptionsLevel(subs: unknown): boolean {
  if (!Array.isArray(subs) || subs.length === 0) {
    return false;
  }
  return (subs as { sub?: unknown }[]).every((node) => {
    const sub = node.sub;
    return sub === undefined || sub === null || (Array.isArray(sub) && sub.length === 0);
  });
}

export function type14NestedSearchable(field: { values?: unknown; fielddependencies?: unknown } | null | undefined): boolean {
  const deps = parseFieldDependencies(field?.fielddependencies);
  if (deps && typeof deps.searchableSublevels === 'boolean') {
    return deps.searchableSublevels;
  }
  return hasThreeLevelType14Tree(field?.values);
}

function parseFieldDependencies(raw: unknown): { searchableSublevels?: boolean } | null {
  const parsed = parseJsonIfString(raw);
  if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
    return parsed as { searchableSublevels?: boolean };
  }
  return null;
}

function parseJsonIfString(raw: unknown): unknown {
  if (typeof raw !== 'string') {
    return raw;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
